/**
 * useContactVerificationPort — port-factory hook returning a stable
 * ContactVerificationPort adapter for production composition.
 *
 * The composer (`Composition`) and the test harness call this once to obtain a
 * ContactVerificationPort instance for PortsProvider. useState's lazy
 * initialiser keeps the adapter reference stable across re-renders (and gives a
 * fresh adapter per React root).
 *
 * 036: this now builds the REAL server-backed `ServerContactVerificationAdapter`
 * over the always-on `member.contactVerification.*` tRPC surface (the member's
 * cookie session authenticates the same-origin request). The "last verified on"
 * fact is a durable server record, so the prompt is trustworthy across devices
 * (SC-007). The retired `DemoContactVerificationAdapter` (browser-local) survives
 * ONLY as a test fixture under `__fixtures__/`, never in the shipped path
 * (SC-009) — enforced by the `no-contact-verification-adapter-import` guard.
 *
 * Owned by 026-proto-convergence-v2; reworked by 036-contact-verification-cadence.
 */

import { useState } from 'react';
import type { ContactVerificationPort } from '../contact-verification/ContactVerificationPort.js';
import { ServerContactVerificationAdapter } from '../contact-verification/ServerContactVerificationAdapter.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useContactVerificationPort(): ContactVerificationPort {
  const [port] = useState<ContactVerificationPort>(
    () => new ServerContactVerificationAdapter({ client: createWebTrpcClient() }),
  );

  return port;
}
